module.exports = "<router-outlet></router-outlet>\n<ngx-loading-bar [includeBar]=\"false\"></ngx-loading-bar>"